import styled from "styled-components";
import { device } from "../../styles/devices";

export const TechStackItem = styled.li`
    display: flex;
    align-items: center;

    i{
        font-size: 1.5rem;
        color: var(--color-title);
        margin-right: .5rem;

        @media ${device.mobileSmall}{
            margin-right: .2rem;
        }
    }

    p{
        font-size: 1rem;
        font-weight: var(--font-medium);
        line-height: 1.5rem;
        color: var(--color-text);

        @media ${device.mobileSmall}{
            font-size: .9rem;
            line-height: 1.4rem;
        }
    }
`;